import React from "react";

const ContactInfo = () => {
  return (
    <>
      <div className="contact-info">
        <h4>What’s your story? Get in touch</h4>
        <p>
          Always available for freelancing if the right project comes along,
          Feel free to contact me.
        </p>

        <ul>
          <li className="media">
            <i className="icon icon-envelope"></i>
            <span className="media-body">laksh.parnami@gmail.com</span>
          </li>

          <li className="media">
            <i className="icon icon-phone"></i>
            <span className="media-body">+91 8107 958922</span>
          </li>
        </ul>
      </div>
      {/* End .contact-info */}
    </>
  );
};

export default ContactInfo;
